import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDesktopOnly = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      fill="#E6ECF4"
      d="M30.369 27.184c-7.913 0-14.327 6.414-14.327 14.327h28.654c0-7.913-6.414-14.327-14.327-14.327M22.41 14.449a7.96 7.96 0 1 0 15.919 0 7.96 7.96 0 0 0-15.92 0"
    />
    <path fill="#fff" d="M22.41 25.592H3.306L6.49 41.51h19.103z" />
    <path
      stroke="#26368A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M22.41 25.592H3.306L6.49 41.51h19.103zM25.593 41.51h9.551M44.695 41.51c0-7.912-6.414-14.326-14.327-14.326q-.807 0-1.592.087M22.41 14.449a7.96 7.96 0 1 0 15.919 0 7.96 7.96 0 0 0-15.92 0"
    />
  </svg>
);
export default SvgDesktopOnly;
